import { styled } from '@mui/material/styles';

import { Typography } from '../../../components/atoms/Typography';

export const MyReportsListTypography = styled(Typography)`
  padding-bottom: 10px;
`;